import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function createCompanyBpmFunc(requestBody) {
  return request({
    url: URL.mdm.companyBpm.createCompanyBpmUrl,
    method: 'post',
    data: requestBody
  })
}

export function getWorkFlowCompany(params) {
  return request({
    url: URL.mdm.companyBpm.getWorkFlowCompanyUrl,
    method: 'get',
    params
  })
}
